module.exports = __webpack_public_path__ + "static/media/fig-testing-process.e4b2429a.svg";